import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';

class Signup1 extends Component {
  constructor() {
    super();
    this.state = {
      fields: {},
      errors: {},
      showPwd: false
    }
  };

  handleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });
  }


  submituserRegistrationForm = (e) => {
    e.preventDefault();
    let errors = {};
    let SignUp1Controller = this;
    let emailId = {"emailId":SignUp1Controller.state.fields.email};
    if (this.validateForm(e)) {
      $.ajax({
        url: "/api/validate-email",
        type: 'POST',
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
        },
        async: false,
        data: emailId,
        success: function (res) {
          if (res.success === true) {
            var signup1data = {
              "fullName": SignUp1Controller.state.fields.fullname, "emailId": SignUp1Controller.state.fields.email,
              "password": SignUp1Controller.state.fields.password
            };
            SignUp1Controller.props.history.push({
              pathname: '/signup/step2',
              state: { signup1data: signup1data }
            });
          } else {
            errors["response"] = res.result;
            SignUp1Controller.setState({
              errors: errors
            });
          }
        }
      });
    }
  }

  validateForm() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["fullname"]) {
      formIsValid = false;
      errors["fullname"] = "*Please enter your full name";
    }

    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "*Please enter your Email ID";
    }

    if (typeof fields["email"] !== "undefined") {
      var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
      if (!pattern.test(fields["email"])) {
        formIsValid = false;
        errors["email"] = "*Please enter valid Email ID";
      }
    }

    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "*Please enter your password";
    }

    if (typeof fields["password"] !== "undefined") {
      if (!fields["password"].match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
        formIsValid = false;
        errors["password"] = "*Please enter secure and strong password";
      }
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  validateFullName = () => {
    let fields = this.state.fields;
    let errors = {};

    if (!fields["fullname"]) {
      errors["fullname"] = "*Please enter your full name";
    }
    this.setState({
      errors: errors
    });
  }

  validateEmail = () => {
    let fields = this.state.fields;
    let errors = {};

    if (!fields["email"]) {
      errors["email"] = "*Please enter your Email ID";
    }


    if (typeof fields["email"] !== "undefined") {
      var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
      if (!pattern.test(fields["email"])) {
        errors["email"] = "*Please enter valid Email ID";
      }
    }
    this.setState({
      errors: errors
    });
  }

  validatePassword = () => {
    let fields = this.state.fields;
    let errors = {};

    if (!fields["password"]) {
      errors["password"] = "*Please enter your password";
    }

    if (typeof fields["password"] !== "undefined") {
      if (!fields["password"].match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,30}/)) {
        errors["password"] = "*Please enter secure and strong password";
      }
    }

    // if (fields["password"] !== fields["confirmpwd"]) {
    //   formIsValid = false;
    //   errors["confirmpwd"] = "*Passwords don't matched";
    // }
    this.setState({
      errors: errors
    });
  }

  showPassword = () => {
    if (this.state.showPwd) {
      this.setState({ showPwd: false });
    } else {
      this.setState({ showPwd: true });
    }
  }

  render() {
    return (
      <div className="wrapper">
        <form method="post">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg-12 p-0">
                <div className="card sign-in-right-tab">
                  <div className="card-body sign-in-page">
                    <div className="col-sm-12">
                      <div className="logoBox mb-2">
                        <img src="./assets/images/dheeai.png" alt="" />
                        <h5 className="signinTitle">Create a Developer Account</h5>
                        <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.response}</div>
                      </div>
                    </div>
                    <div className="col-9 p-0 mx-auto ">
                      <div className="form-group">
                        <div className="step1to3">Step 1 of 3</div>
                        <div className="crplan mt-1">Set up your credentials</div><br />

                        <div className="input-group mb-3">
                          <input type="text" className="form-control" onBlur={this.validateFullName} name="fullname" onChange={this.handleChange} placeholder="Full Name *" />
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.fullname}</div>
                        </div>

                        <div className="input-group mb-3">
                          <input type="email" className="form-control" name="email" onBlur={this.validateEmail} onChange={this.handleChange} placeholder="Email ID *" />
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.email}</div>
                        </div>

                        <div className="input-group mb-3">
                          <input type={this.state.showPwd ? "text" : "password"} className="form-control sign-in-forminput passinput noMar" onBlur={this.validatePassword} name="password"
                            onChange={this.handleChange} placeholder="Create Password *" />
                          <div className="input-group-append">
                            <button className="btn showPassbtn" type="button" onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button>
                          </div>
                          <span className="pNote">Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.password}</div>
                        </div><br />

                        {/* <div className="input-group mb-3">
                            <input type="password" className="form-control" name="confirmpwd" onFocus={this.validatePassword} onChange={this.handleChange} placeholder="Confirm Password *" />
                            <div className="errorMsg" style={{color:'red'}}>{this.state.errors.confirmpwd}</div>
                          </div> */}
                      </div>
                      <button type="button" className="btn btn-primary btn-block" onClick={this.submituserRegistrationForm}>Proceed</button>
                      <div className="input-group mb-3 ">
                        <div className="fpass col-12 p-0">
                          <span style={{ color: '#b7b4c0' }}>Already have an account?</span>
                          <Link to="/login"> login</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default Signup1;



// WEBPACK FOOTER //
// ./src/signup/Signup1.js